import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

export const postCardAnimations = () => {
	const postCards = document.querySelectorAll('.js-post-card');

	if (postCards) {
		postCards.forEach(card => {
			const image = card.querySelector('.post-card__image');
			const hoverElems = card.querySelector('.post-card__content-hover-elems');

			gsap.registerPlugin(CustomEase);
			let mm = gsap.matchMedia();

			mm.add(
				'(prefers-reduced-motion: no-preference) and (min-width: 992px) and (hover: hover) and (pointer: fine)',
				context => {
					let tl = gsap.timeline({
						paused: true,
					});

					tl.addLabel('start');

					tl.to(
						image,
						{
							scale: 1.3,
							y: '-15%',
							duration: 0.8,
							ease: CustomEase.create('post-card', '.4, 0, .2, 1'),
						},
						'start'
					);

					tl.to(
						hoverElems,
						{
							height: 'auto',
							opacity: 1,
							duration: 0.8,
							ease: CustomEase.create('post-card', '.4, 0, .2, 1'),
						},
						'start'
					);

					card.addEventListener('mouseenter', () => {
						tl.play();
					});
					card.addEventListener('focusin', () => {
						tl.play();
					});

					card.addEventListener('mouseleave', () => {
						tl.reverse();
					});
					// When the focused element is not the card or is not a child of the card, reverse the animation
					card.addEventListener('focusout', e => {
						tl.reverse();
					});
				}
			);
		});
	}
};

postCardAnimations();
